import { Sparkles, MousePointerClick, Layout, Smartphone, Shield, ShoppingCart } from 'lucide-react';
import WebBuilderImage from "@/assets/images/websites/banner.png";

export default function WebsiteFeatures() {
    const features = [
        {
            icon: Sparkles,
            title: "Smart automation tools",
            description: "Automate content and workflows to grow your online presence faster."
        },
        {
            icon: MousePointerClick,
            title: "Simple drag-and-drop editor",
            description: "Build and customize your website easily with a visual editor."
        },
        {
            icon: Layout,
            title: "Professional design templates",
            description: "Choose customizable templates designed for modern businesses."
        },
        {
            icon: Smartphone,
            title: "Responsive on all devices",
            description: "Deliver a seamless experience across mobile, tablet, and desktop."
        },
        {
            icon: Shield,
            title: "Enterprise-grade security",
            description: "Protect your website and customer data with built-in security."
        },
        {
            icon: ShoppingCart,
            title: "Full e-commerce capabilities",
            description: "Sell online with tools for payments, products, and order management."
        }
    ];

    return (
        <section className="relative py-12 lg:py-20">
            <div className="container">
                {/* Header */}
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-4">
                        Build a website that drives your business forward
                    </h2>
                    <p className="text-gray-300 md:text-lg max-w-2xl mx-auto">
                        Everything you need to create a stunning online presence
                    </p>
                </div>

                {/* Main Image */}
                <div className="relative mb-12 md:mb-20 max-w-6xl mx-auto">
                    <div className="relative rounded-3xl overflow-hidden">
                        <div className="absolute inset-0 bg-gradient-to-r from-purple-600/10 to-blue-600/10 blur-3xl"></div>
                        <div className="relative h-[200px] md:h-[400px] lg:h-[500px] rounded-2xl overflow-hidden">
                            <img
                                src={WebBuilderImage}
                                alt="Website Builder Interface"
                                className="w-full h-full object-cover rounded-2xl shadow-2xl shadow-purple-500/20"
                            />
                        </div>
                    </div>
                </div>

                {/* Features Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
                    {features.map((feature, index) => {
                        const Icon = feature.icon;
                        return (
                            <div key={index} className="group">
                                <div className="h-full rounded-2xl bg-gradient-to-br from-purple-600/5 to-blue-600/5 border border-purple-500/20 p-6 md:p-8 hover:border-purple-500/50 hover:bg-gradient-to-br hover:from-purple-600/10 hover:to-blue-600/10 transition-all duration-300">
                                    <div className="mb-6">
                                        <div className="w-14 h-14 rounded-xl bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center text-white group-hover:scale-110 transition-all duration-300">
                                            <Icon className="w-7 h-7" strokeWidth={2} />
                                        </div>
                                    </div>

                                    <h3 className="text-xl font-bold text-white mb-4">
                                        {feature.title}
                                    </h3>

                                    <p className="text-gray-300 text-base leading-relaxed">
                                        {feature.description}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}